module.exports = __webpack_public_path__ + "img/gift.e6015671.svg";